import './ChecklistAddItemModal.scss';

import React from 'react';
import update from 'immutability-helper';
import classNames from 'classnames';
import clone from 'clone';

import ChecklistAddItemForm from './ChecklistAddItemForm';
import ImageCropper from 'components/ImageCropper';
import Modal from 'components/Modal';

export default class ChecklistAddItemModal extends React.Component {
    static propTypes = {
        closeModal: React.PropTypes.func.isRequired,
        contentPiece: React.PropTypes.object.isRequired,
        setContentSingle: React.PropTypes.func.isRequired,
        show: React.PropTypes.bool.isRequired,
    };

    constructor() {
        super();

        this.emptyItem = {
            information: '',
            name: '',
            thumbnail: null,
            type: 'yes_no'
        };

        this.state = {
            item: {},
            showCropper: false
        }
    }

    componentWillMount() {
        this.setState({item: clone(this.emptyItem)});
    }

    componentWillReceiveProps(nextProps) {
        if(this.props.itemEditIndex !== nextProps.itemEditIndex && nextProps.itemEditIndex != null) {
            console.log('itemeditindex', nextProps.itemEditIndex)
            this.setState({item: this.props.contentPiece.items[nextProps.itemEditIndex]});
        }
    }

    handleAnswerTypeChange(type) {
        let item = update(this.state.item, {
            type: {$set: type}
        });
        this.setState({item}, () => console.log(this.state.item));
    }

    handleChange(event) {
        let item = update(this.state.item, {});
        item[event.target.name] = event.target.value;
        this.setState({item});
    }

    handleCrop(crop) {
        let item = update(this.state.item, {
            thumbnail: {$set: crop}
        });
        this.setState({item, showCropper: false}, () => console.log(this.state.item));
    }

    handleSubmit(isValid) {
        if(isValid === true) {
            let newContentPieceObj = update(this.props.contentPiece, {});

            if(this.props.itemEditIndex == null) {
                newContentPieceObj.items.push(this.state.item);
            } else {
                newContentPieceObj.items[this.props.itemEditIndex] = this.state.item;
            }

            console.log(newContentPieceObj);
            this.props.setContentSingle(newContentPieceObj);
            this.props.closeModal();
            this.setState({item: clone(this.emptyItem)});
        }
    }

    handleThumbnailChange(file) {
        let item = update(this.state.item, {
            thumbnail: {$set:file}
        });
        this.setState({item, showCropper: file != null});
    }

    render() {
        let { show } = this.props;

        console.log('item', this.state.item);

        return (
            <Modal show={show}
                   className={classNames('checklist-add-item edit-modal', {'checklist-add-item--showing-cropper': this.state.showCropper === true})}
                   handleClose={() => {
                       this.props.closeModal();
                       this.setState({item: clone(this.emptyItem)});
                   }}
                   width={this.state.showCropper === true ? 'full' : 'wide'}>
                <div className="checklist-add-item__form-wrapper">
                    {this.state.showCropper === true ? (
                        <ImageCropper
                            file={this.state.item.thumbnail}
                            handleCancel={() => {
                                this.handleThumbnailChange(null);
                            }}
                            handleCrop={this.handleCrop.bind(this)}
                        />
                    ) : (
                        <ChecklistAddItemForm
                            closeModal={() => {
                                this.props.closeModal();
                                this.setState({item: clone(this.emptyItem)});
                            }}
                            handleAnswerTypeChange={this.handleAnswerTypeChange.bind(this)}
                            handleChange={this.handleChange.bind(this)}
                            handleThumbnailChange={this.handleThumbnailChange.bind(this)}
                            item={this.state.item}
                            onInvalid={this.handleSubmit.bind(this, false)}
                            onValid={this.handleSubmit.bind(this, true)}
                        />
                    )}

                </div>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/ContentPage/modals/ChecklistAddItemModal/index.js